import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import {
	getKeyPersonnel,
	getKeyPersonnelListPaginated,
} from "../key-personnel-api";
import type {
	KeyPersonnelListParams,
	KeyPersonnelPageResponse,
} from "../types/KeyPersonnel.type";

export const KEY_PERSONNEL_KEYS = {
	all: ["key-personnel"] as const,
	list: (params?: KeyPersonnelListParams) =>
		params
			? ([...KEY_PERSONNEL_KEYS.all, "list", params] as const)
			: ([...KEY_PERSONNEL_KEYS.all, "list"] as const),
	paginatedList: (params: KeyPersonnelListParams) =>
		[...KEY_PERSONNEL_KEYS.all, "paginated", params] as const,
	detail: (id: number) =>
		[...KEY_PERSONNEL_KEYS.all, "detail", id] as const,
};

export const useKeyPersonnelList = (params: KeyPersonnelListParams = {}) => {
	return useQuery<KeyPersonnelPageResponse>({
		queryKey: KEY_PERSONNEL_KEYS.list(params),
		queryFn: () => getKeyPersonnelListPaginated(params, params.page ?? 1),
	});
};

export const useKeyPersonnelDetail = (id: number) => {
	return useQuery({
		queryKey: KEY_PERSONNEL_KEYS.detail(id),
		queryFn: () => getKeyPersonnel(id),
		enabled: id > 0,
	});
};

export const useKeyPersonnelPaginatedList = (
	params: KeyPersonnelListParams,
	enabled = true,
) => {
	return useInfiniteQuery<KeyPersonnelPageResponse>({
		queryKey: KEY_PERSONNEL_KEYS.paginatedList(params),
		queryFn: ({ pageParam }) =>
			getKeyPersonnelListPaginated(params, pageParam as number),
		initialPageParam: 1,
		getNextPageParam: (lastPage) =>
			lastPage.pagination?.has_more_pages
				? lastPage.pagination.current_page + 1
				: undefined,
		enabled,
	});
};
